<template>
    <div class="rechargeHistory-container" v-wechat-title="'mysread'">
        <vue-element-loading :active="isRequest" :is-full-screen="true" spinner="bar-fade-scale" color="#FF6700" />

        <!--頂部欄-->
        <div class="top-nav-container">
            <span>儲值記錄</span>
            <span @click="backClick" style="position: absolute; left: 10px">返回</span>
        </div>

        <div class="rechargeListContainer">
            <ul>
                <li v-for="recharge in rechargeList">
                    <span style="width: 15%">{{ recharge.title }}</span>
                    <span style="width: 15%">{{ recharge.zffs }}</span>
                    <span style="width: 30%">{{ recharge.je1 }}異幣</span>
                    <span style="width: 50%; text-align: right">{{ recharge.rq }}</span>
                </li>
            </ul>

            <div @click="loadMore" class="more-style" v-if="showLoadMore">
                <span>更多</span>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "RechargeHistoryVue",
    data() {
        return {
            isRequest: false,
            userId: "",
            page: 1,
            allPages: 0,
            rechargeList: [],
            isLoadMore: false,
            showLoadMore: true,
        };
    },
    methods: {
        //返回
        backClick: function () {
            this.$router.go(-1);
        },

        getRechargeHistory: function () {
            const params = new URLSearchParams();
            params.append("language", "zh-Hant");
            params.append("dev", "h5");
            params.append("uuid", "123456");
            params.append("ver", "1.0");
            params.append("ac", "getChargeList");
            params.append("uid", this.userId);
            params.append("page", this.page);
            this.isRequest = true;
            this.$http.post(axios.baseURL, params).then((res) => {
                this.isRequest = false;
                if (res.data.status) {
                    this.allPage = res.data.pages;
                    this.showLoadMore = this.page < this.allPage;
                    if (this.isLoadMore) {
                        let list = res.data.data;
                        for (let i = 0; i < list.length; i++) {
                            this.rechargeList.push(list[i]);
                        }
                    } else {
                        this.rechargeList = res.data.data;
                    }
                } else {
                    alert(res.data.msg);
                }
            });
        },

        //加載更多
        loadMore: function () {
            this.isLoadMore = true;
            this.page++;
            this.getRechargeHistory();
        },
    },

    created() {
        this.userId = localStorage.getItem("userId");
        this.getRechargeHistory();
    },
};
</script>

<style scoped>
.rechargeHistory-container {
    max-width: 480px;
    min-height: calc(100vh - 50px);
    margin: 0 auto;
    background-color: white;
}

.rechargeListContainer {
    margin-top: 50px;
    overflow-x: hidden;
}

.rechargeListContainer ul {
    text-align: left;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 10px;
    margin-inline-end: 10px;
    padding-inline-start: 0;
}

.rechargeListContainer ul li {
    line-height: 40px;
    border-bottom: 1px solid whitesmoke;
    display: flex;
    flex-direction: row;
}

.rechargeListContainer ul li span {
    font-size: 16px;
    color: #333333;
    margin-left: 10px;
}

.more-style {
    height: 40px;
}

.more-style span {
    line-height: 40px;
}

.more-style:active {
    background-color: lightgrey;
}
</style>



// WEBPACK FOOTER //
// src/components/RechargeHistoryVue.vue